import * as React from 'react'
import styled from 'styled-components'

import * as models from '@owl-nest/models'
import * as plume from '@ulule/owl-kit-components/next'

type CoachingProps = {
  children: React.ReactNode
  className?: string
  project: models.project.ProjectForOwner
}

function CoachingComponent({ project, children, className }: CoachingProps) {
  const manager = project.manager ?? project.default_manager
  return (
    <div className={className}>
      {manager && <plume.styles.image.Avatar src={models.user.avatar(manager, 'full')} type="small" withShadow />}
      <plume.styles.copy.S asDesktop="M">{children}</plume.styles.copy.S>
    </div>
  )
}

export const Coaching = styled(CoachingComponent)`
  display: flex;
  margin: 16px 0 32px;

  ${plume.styles.copy.S}, ${plume.styles.copy.M} {
    background: ${plume.COLORS.PRIMARY_SAND_100};
    border-radius: 4px;
    font-weight: 600; /* HACK: Irregular font manipulation. We'll be adding copy.S.semiBold & copy.M.semiBold, so this is just by anticipation. */
    margin-left: 16px;
    padding: 16px;
    width: 100%;
  }

  @media screen and ${plume.BREAKPOINTS.TABLET} {
    margin: 52px 32px 32px;
  }
`
